export const NavCypressAttribute = {
  buttons: {
    EXIT_ESTATE: 'nav/buttons/EXIT_ESTATE',
    USER_MENU_DROPDOWN: 'nav/buttons/USER_MENU_DROPDOWN',
    SPOTLIGHT: 'NavCypressAttribute:buttons:SPOTLIGHT',
    INBOX: 'nav/buttons/INBOX',
    LOGOUT: 'nav/buttons/LOGOUT',
    NAV_ITEM: 'nav/buttons/NAV_ITEM',
    BILLING: 'NavCypressAttribute:buttons:BILLING',
    BILLING_ROUTER: 'NavCypressAttribute:buttons:BILLING_ROUTER',
    BILLING_DROPDOWN: 'NavCypressAttribute:buttons:BILLING_DROPDOWN',
    CHANGE_ESTATE: 'NavCypressAttribute:CHANGE_ESTATE',
    CLEAR_DESK: 'nav/buttons/CLEAR_DESK',
    ESTATE_SETTINGS: 'nav/buttons/ESTATE_SETTINGS',
    REFER_LOVED_ONE: 'nav/button/REFER_LOVED_ONE'
  },
  inputs: {},
  views: {
    HEADER: 'NavCypressAttribute:views:HEADER',
    FOOTER: 'NavCypressAttribute:views:FOOTER',
    MENU: 'NavCypressAttribute:MENU',
    CHILDREN: 'NavCypressAttribute:CHILDREN',
    CUSTOM_BADGE: 'NavCypressAttribute:CUSTOM_BADGE',
    LOCK_ICON: 'NavCypressAttribute:LOCK_ICON',
    NAV_ITEM_TOOLTIP: 'NavCypressAttribute:NAV_ITEM_TOOLTIP',
    NAV_ITEM: 'NavCypressAttribute:NAV_ITEM',
    NAV_GROUP_SEPARATOR: 'NavCypressAttribute:views:NAV_GROUP_SEPARATOR'
  },
  texts: {
    NAV_GROUP_TITLE: 'NavCypressAttribute:texts:NAV_GROUP_TITLE',
    POWERED_BY_TEXT: 'NavCypressAttribute:POWERED_BY_TEXT',
    APP_VERSION: 'NavCypressAttribute:texts:APP_VERSION'
  }
};
